<!-- DIY模板 -->
<template>
    <div class="container">
        <div class="header">
            <Input
                class="w200 mr24 mb24"
                type="text"
                v-model="storePrams.name"
                clearable
                placeholder="请输入模板名称"
            ></Input>
            <Button
                class="theme-bc mb24 theme-default-color"
                icon="ios-search"
                @click="goSearch"
                >确认搜索</Button
            >
        </div>
        <div class="content">
            <Button
                class="theme-bc mb24 theme-default-color"
                icon="md-add-circle"
                @click="goModal(1)"
                >新增模板</Button
            >
            <Table :columns="columnsTable" :data="dataTable" border>
                <template slot-scope="{ row }" slot="title">
                    <div class="flex-c cursor-pointer" @click="goModal(1, row)">
                        <div>{{ row.title }}</div>
                        <img
                            src="@/assets/edit_name.png"
                            alt=""
                            class="title-img"
                        />
                    </div>
                </template>
                <template slot-scope="{ row }" slot="operate">
                    <div class="flex-sa">
                        <Button type="primary" ghost @click="goManage(row)"
                            >管理</Button
                        >
                        <Button class="btn-copy" @click="goCopy(row)"
                            >复制</Button
                        >
                        <Button type="error" ghost @click="goDel(1, row)"
                            >删除</Button
                        >
                    </div>
                </template>
            </Table>
            <div class="ta-r mt24">
                <Page
                    :current="storePrams.page"
                    :total="total"
                    :page-size="storePrams.limit"
                    show-elevator
                    show-total
                    @on-change="pageChange"
                />
            </div>
        </div>
        <!-- 复制模板 -->
        <Modal
            v-model="copyModal"
            title="复制模板"
            width="500"
            :mask-closable="false"
        >
            <div>
                <Form
                    :model="formItem"
                    label-position="right"
                    :label-width="100"
                >
                    <FormItem label="模板名称">
                        <Input
                            type="text"
                            v-model="formItem.title"
                            placeholder="请输入模板名称"
                        ></Input>
                    </FormItem>
                </Form>
            </div>
            <div slot="footer">
                <Button @click="cancelCopyModal">取消</Button>
                <Button
                    class="theme-bc theme-default-color"
                    @click="submitCopyModal"
                    >确定</Button
                >
            </div>
        </Modal>
        <!-- 模板管理 -->
        <Modal
            v-model="manageModal"
            title="模板管理"
            width="1000"
            :mask-closable="false"
        >
            <div>
                <Button
                    class="theme-bc mb24 theme-default-color"
                    icon="md-add-circle"
                    @click="goModal(2)"
                    >新增页面</Button
                >
                <Table :columns="columnManage" :data="dataManage" border>
                    <template slot-scope="{ row }" slot="link">
                        <Button @click="goCopyLink(row)">复制</Button>
                    </template>
                    <template slot-scope="{ row }" slot="operate">
                        <div class="flex-sa">
                            <div class="w90">
                                <Button
                                    v-if="row.is_index != 1"
                                    type="success"
                                    ghost
                                    @click="setHome(row)"
                                    >设为首页</Button
                                >
                            </div>
                            <Button
                                type="primary"
                                ghost
                                @click="goModal(2, row)"
                                >编辑</Button
                            >
                            <Button type="error" ghost @click="goDel(2, row)"
                                >删除</Button
                            >
                        </div>
                    </template>
                </Table>
                <div class="ta-r mt24">
                    <Page
                        :current="storePramsManage.page"
                        :page-size="storePramsManage.limit"
                        :total="totalManage"
                        show-elevator
                        show-total
                        @on-change="pageChangeManage"
                    />
                </div>
            </div>
            <div slot="footer"></div>
        </Modal>
        <!-- 新增模板/编辑模板 -->
        <Modal
            v-model="modals"
            :title="modalTitle"
            width="500"
            :mask-closable="false"
        >
            <div>
                <Form
                    :model="formItem"
                    label-position="right"
                    :label-width="100"
                >
                    <FormItem label="模板名称">
                        <Input
                            type="text"
                            v-model="formItem.title"
                            placeholder="请输入模板名称"
                        ></Input>
                    </FormItem>
                </Form>
            </div>
            <div slot="footer">
                <Button @click="cancelModal">取消</Button>
                <Button
                    class="theme-bc theme-default-color"
                    @click="submitModal"
                    >确定</Button
                >
            </div>
        </Modal>
        <!-- 新增页面 -->
        <Modal
            v-model="page_modal"
            title="新增页面"
            width="500"
            :mask-closable="false"
        >
            <div>
                <Form
                    :model="page_data"
                    label-position="right"
                    :label-width="100"
                >
                    <FormItem label="页面名称：">
                        <Input
                            type="text"
                            v-model="page_data.title"
                            placeholder="请输入页面名称"
                        ></Input>
                    </FormItem>
                </Form>
            </div>
            <div slot="footer">
                <Button @click="cancelPageModal">取消</Button>
                <Button
                    class="theme-bc theme-default-color"
                    @click="submitPageModal"
                    >确定</Button
                >
            </div>
        </Modal>
    </div>
</template>

<script>
import {
    template_diy_list,
    template_diy_copy,
    template_diy_manage,
    template_diy_del,
    template_diy_save,
    template_diy_del_manage,
    template_diy_set,
} from "@/api/index";
export default {
    data() {
        return {
            storePrams: {
                page: 1,
                limit: 10,
                name: "",
            },
            total: 0,
            columnsTable: [
                { type: "index", width: 60, align: "center" },
                { title: "模板名称", slot: "title", align: "center" },
                {
                    title: "创建时间",
                    key: "created_at",
                    align: "center",
                    width: "200px",
                },
                {
                    title: "操作",
                    slot: "operate",
                    align: "center",
                    width: "300px",
                },
            ],
            dataTable: [],
            storePramsManage: {
                page: 1,
                limit: 10,
                id: "",
            },
            totalManage: 0,
            columnManage: [
                { type: "index", width: 60, align: "center" },
                { title: "页面名称", key: "title", align: "center" },
                { title: "页面链接", slot: "link", align: "center", width: "100px" },
                {
                    title: "操作",
                    slot: "operate",
                    align: "center",
                    width: "300px",
                },
            ],
            dataManage: [],
            copyModal: false,
            manageModal: false,
            modals: false,
            modalTitle: "",
            manageData: {
                id: "",
                diy_template_id: "",
            },
            formItem: {
                title: "",
                id: "",
            },
            page_modal: false,
            page_data: {
                title: "",
            },
        };
    },
    mounted() {
        this.dataTable = [];
        this.getList();
    },
    methods: {
        cancelPageModal() {
            this.page_modal = false;
        },
        submitPageModal() {
            this.manageData.id = "";
            if (!this.page_data.title) {
                this.$Message.error("请填写页面名称");
                return;
            }
            this.page_modal = false;
            // 跳转DIY
            // diy_id == 1（产品模板）
            this.$router.push({
                path: `/admin/formwork/editDiy?id=${this.manageData.id}&diy_template_id=${this.manageData.diy_template_id}&diy_id=1&title=${this.page_data.title}`,
            });
        },
        goSearch() {
            this.storePrams.page = 1;
            this.getList();
        },
        getList() {
            template_diy_list(this.storePrams)
                .then((res) => {
                    this.dataTable = res.data.data;
                    this.total = res.data.total;
                    // 删除后，page--
                    if (!res.data.data.length && this.storePrams.page != 1) {
                        this.storePrams.page--;
                        this.getList();
                    }
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        // Page @on-change
        pageChange(index) {
            this.storePrams.page = index;
            this.getList();
        },
        pageChangeManage(index) {
            this.storePramsManage.page = index;
            this.getManageList();
        },
        // 设置默认首页
        setHome(row) {
            this.$Modal.confirm({
                title: "提示",
                content: "确认设置默认首页为（" + row.title + "）吗？",
                onOk: () => {
                    template_diy_set({ id: row.id })
                        .then((res) => {
                            this.getManageList();
                            this.$Message.success(res.msg);
                        })
                        .catch((res) => {
                            this.$Message.error(res.msg);
                        });
                },
                onCancel: () => {},
            });
        },
        // DIY模板管理列表
        getManageList() {
            template_diy_manage(this.storePramsManage)
                .then((res) => {
                    this.dataManage = res.data.data;
                    this.totalManage = res.data.total;
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        // 删除
        goDel(index, row) {
            this.$Modal.confirm({
                title: "删除提示",
                content: "确认删除吗？一经删除无法复原",
                onOk: () => {
                    if (index == 1) {
                        template_diy_del({ id: row.id })
                            .then((res) => {
                                this.getList();
                                this.$Message.success(res.msg);
                            })
                            .catch((res) => {
                                this.$Message.error(res.msg);
                            });
                    } else if (index == 2) {
                        template_diy_del_manage({ id: row.id })
                            .then((res) => {
                                this.getManageList();
                                this.$Message.success(res.msg);
                            })
                            .catch((res) => {
                                this.$Message.error(res.msg);
                            });
                    }
                },
                onCancel: () => {},
            });
        },
        goCopy(row) {
            this.formItem.title = row.title;
            this.formItem.id = row.id;
            this.copyModal = true;
        },
        goManage(row) {
            this.storePramsManage.id = row.id;
            this.manageData.diy_template_id = row.id;
            this.getManageList();
            this.manageModal = true;
        },
        goModal(index, row) {
            if (index == 1) {
                if (row) {
                    this.modalTitle = "编辑模板";
                    this.formItem.title = row.title;
                    this.formItem.id = row.id;
                } else {
                    this.modalTitle = "新增模板";
                    this.formItem.id = "";
                    this.formItem.title = "";
                }
                this.modals = true;
            } else if (index == 2) {
                if (row) {
                    this.manageData.id = row.id;
                    // 跳转DIY
                    // diy_id == 1（产品模板）
                    this.$router.push({
                        path: `/admin/formwork/editDiy?id=${this.manageData.id}&diy_template_id=${this.manageData.diy_template_id}&diy_id=1`,
                    });
                } else {
                    // 新增页面
                    this.page_modal = true;
                }
            }
        },
        // 取消
        cancelCopyModal() {
            this.copyModal = false;
        },
        // 确定
        submitCopyModal() {
            template_diy_copy(this.formItem)
                .then((res) => {
                    this.getList();
                    this.copyModal = false;
                    this.$Message.success(res.msg);
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        // 取消
        cancelModal() {
            this.modals = false;
        },
        // 确定
        submitModal() {
            template_diy_save(this.formItem)
                .then((res) => {
                    this.getList();
                    this.modals = false;
                    this.$Message.success(res.msg);
                })
                .catch((res) => {
                    this.$Message.error(res.msg);
                });
        },
        goCopyLink(row) {
            let text = row.link;
            this.$copyText(text).then(
                (e) => {
                    this.$Message.success({
                        background: true,
                        content: "复制成功",
                        closable: true,
                    });
                },
                (err) => {
                    this.$Message.error("复制失败");
                }
            );
        },
    },
};
</script>

<style scoped>
.container {
    display: flex;
    flex-direction: column;
}
.header {
    padding: 24px 24px 0 24px;
    margin-bottom: 24px;
    background-color: #fff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
}
.content {
    padding: 24px;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
    height: 100%;
}
.btn-copy {
    border: 1px solid #6c52ff;
    color: #6c52ff;
}
.w90 {
    width: 90px;
}
.ta-r {
    text-align: right;
}
.title-img {
    width: 16px;
    height: 16px;
    margin-left: 24px;
}
.cursor-pointer {
    cursor: pointer;
}
/* 表头背景颜色 */
::v-deep .ivu-table-header thead tr th {
    background: rgba(198, 44, 44, 0) !important;
    box-shadow: 0px 1px 0px 0px rgba(234, 234, 234, 0.99);
}
/* 表头字体颜色 */
::v-deep .ivu-table-wrapper .ivu-table .ivu-table-header tr th {
    color: #484e66 !important;
    font-family: Source Han Sans CN;
    font-size: 14px;
    font-weight: bold;
}
/* table中所有的边框  */
::v-deep .ivu-table td {
    border-left: none;
    border-right: none;
}
::v-deep .ivu-table th {
    border-left: none;
    border-right: none;
}
::v-deep .ivu-form-item {
    margin-bottom: 0;
}
</style>